export enum SchoolSignUpScreens {
	SchoolInfo = 'school-info',
	ManagerInfo = 'manager-info',
	Success = 'success'
}